/* eslint-disable simple-import-sort/imports */

import { logEvent as gaLogEvent, getAnalytics, isSupported } from 'firebase/analytics';
import { getApp, getApps, initializeApp } from 'firebase/app';
import { reduxStore, selectOttVideoDetails } from 'src/lib/redux';
import { isOTT } from 'src/lib/utilities';
import { logger } from 'src/services/logger/loggerService';

import { EventType } from './events';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

const batchDetails = JSON.parse(localStorage?.getItem('BATCH_DETAILS') || '{}');
const user = JSON.parse(localStorage?.getItem('user') || '{}');

let eventPrefix = '';

export const logEvent = (type: EventType, body: any, shouldPrefix = true, eventSource?: string) => {
  let userId, userName, deviceId, batchId, scheduleId, cohortId;

  const batchDetails = JSON.parse(localStorage?.getItem('BATCH_DETAILS') || '{}');
  const user = JSON.parse(localStorage?.getItem('user') || '{}');
  if (typeof window !== 'undefined') {
    userId = user.id;
    batchId = batchDetails._id;
    scheduleId = JSON.parse(localStorage?.getItem('SCHEDULE_DETAILS') || '{}')._id;
    cohortId = user.profileId?.cohortId;
    userName = localStorage?.getItem('username');
    deviceId = localStorage?.getItem('randomId');
  }
  const data: {
    user_id?: string;
    UserPhoneNumber?: string;
    device_id?: string;
    batch_id?: string;
    schedule_id?: string;
    cohort_id?: string;
  } = {};
  if (eventSource) {
    eventPrefix = 'pw' + eventSource + '_';
  }
  if (userId) {
    data['user_id'] = userId;
  }
  if (batchId) {
    data['batch_id'] = body?.batch_id || batchId;
  }
  if (scheduleId) {
    data['schedule_id'] = scheduleId;
  }
  if (cohortId) {
    data['cohort_id'] = body?.cohort_id || cohortId;
  }
  if (userName) {
    data['UserPhoneNumber'] = userName;
  } else if (body?.UserPhoneNumber) {
    data['UserPhoneNumber'] = body?.UserPhoneNumber;
  }
  if (deviceId) {
    data['device_id'] = deviceId;
  }

  body['player_type'] = 'new';
  const searchParams = new URLSearchParams(window.location.search);
  const vType = searchParams.get('vType');
  if (isOTT()) {
    body['player_type'] = 'ott_player';
    if (type === EventType.PW_PLAYER_LOAD || type === EventType.FIRST_TIME_VIDEO_PLAY) {
      body['default_video_player_feature'] = 'NA';
    }
    const videoType = searchParams.get('type');
    body['video_type'] = videoType;
    body['islive'] = videoType === 'awsVideo';

    const state = reduxStore.getState();
    const ottVideoDetails = selectOttVideoDetails(state);

    // If content_id or video_id keys exist in body, populate them from ottVideoDetails
    if ('content_id' in body && ottVideoDetails?._id) {
      body['content_id'] = ottVideoDetails._id;
    }
    if ('video_id' in body && ottVideoDetails?.videoId) {
      body['video_id'] = ottVideoDetails.videoId;
    }
  }
  const updatedData = { ...body, ...data };
  const app = initializeApp(firebaseConfig);

  const invokeAnalytics = () => {
    const analytics = getAnalytics(app);
    //   const user = window.localStorage.getItem('user')
    //   console.log(user)
    // TODO: Add Firebase event to log events

    body['timestamp'] = new Date();
    let eventName;
    if (shouldPrefix) {
      eventName = eventPrefix + type;
    } else {
      eventName = type;
    }
    logger.log('EVENT NAME>>>>', eventName, updatedData);
    gaLogEvent(analytics, eventName, updatedData);
  };
  isSupported().then((isBrowser: any) => (isBrowser ? invokeAnalytics() : null));
};
